//init function called from different js
var bmyb = {
  stage: '',
  hulltype: 'FullHull',
  StripeArr: [],
  BiminiArr: [],
  VinylArr: [],
  FullhullArr: [],

  storeColours: function (type) {
    var root = this;
    root[type + 'Arr'] = [];
    //console.log("--------------"+type+"--------------");
    jQuery('#' + type + '-selections').find(':radio').each(function () {
      if (jQuery(this).is(':checked')) {
        var me = jQuery(this);
        root[type + 'Arr'].push(me.attr("id"));
        //console.log("saved #"+me.attr("id")+" ["+me.val()+"]");
        me.prop("checked", false);
      } else if ((jQuery(this).val() == "n/a") || (jQuery(this).val() == "notapplicable")) {
        //jQuery(this).prop("checked",true);
        if (!this.checked) {
          //console.log('set [n/a] on for '+type);
          jQuery(this).click();
        }
      }
    });
    //console.log("------------------------------------");
  },

  retrieveColours: function (type) {
    //console.log('--- retrieving '+type+' ---');
    for (var i = 0; i < this[type + 'Arr'].length; i++) {
      jQuery('#' + this[type + 'Arr'][i]).prop("checked", true);
      //console.log('set #'+this[type+'Arr'][i]+' ['+jQuery('#'+this[type+'Arr'][i]).val()+'] checked to true');
    }
    //console.log('</--->');
  },

  jq: function (txt) {
    //rem : or . or & or parenthesis from id/class
    return txt.replace(/((:|\.)|\(|\)|&)/g, '');
  },

  jb: function (txt) {
    //rem parenthesis from txt
    return txt.replace(/(\(|\))/g, '');
  },

  optionClickEvent: function (val, remove) {
    var tbx = jQuery('textarea.SelectedOptions');
    var txt = tbx.val() || tbx.html() || tbx.text();
    if (remove) {
      var needle = val + ', ';
      var mymatch = new RegExp(needle, "g");
      tbx.val(txt.replace(mymatch, ''));
    } else {
      txt += val + ', ';
      tbx.val(txt);
    }
  },

  setupOptionClickEvent: function (objNm) {
    var root = this;
    jQuery('#' + objNm).click(function () {
      var myval = jQuery(this).val();
      if (jQuery(this).is(':checked')) {
        root.optionClickEvent(myval, false);
      } else {
        root.optionClickEvent(myval, true);
      }
    });
  },

  convertOptions: function () {
    //find product options listing and convert to a usable checkbox list which adds values to form submission
    var root = this;
    var container = jQuery('#Options-selections .pbProductPropertyList');
    var optCountr = 1;
    container.find('td').each(function () {
      var optionname = jQuery(this).text();
      var onns = root.jq(optionname.replace(/\s/g, ''));
      jQuery(this).html("<input type='checkbox' name='" + optionname + "' value='" + root.jb(optionname) + "' id='" + onns + optCountr + "' class='" + onns + "' \/><label class='option-chkbox-label " + onns + "' for='" + onns + optCountr + "'>" + optionname + "<\/label>");
      root.setupOptionClickEvent(onns + optCountr);
      optCountr++;
    });
  },

  colourset: function () {
    jQuery('.colourset').find('td').each(function (index) {
      var tdtag = jQuery(this);
      tdtag.addClass(function () {
        var myval = tdtag.find('label').text().replace(/\s/g, '');
        if (myval == "n/a") {
          myval = "notapplicable"
        }
        return myval;
      });
    });
    //find vinyl options and convert values from unique id to name *CMS System Issue Hack/Fix
    jQuery('.vinyl.colourset').find('td').each(function (index) {
      //jQuery(this).find('input').val(jQuery(this).attr('class'));
    });
  },

  setHullType: function (val) {
    this.hulltype = val;
  },

  setHullTypeRadioEvent: function (object) {
    var root = this;
    object.click(function () {
      root.setHullClass('');
      root.setHullType(jQuery(this).val().replace(/ /g, ''));
      root.setHullClass(jQuery('#Fullhull-selections .Fullhull.colours').find(':radio:checked').val().toLowerCase().replace(/ /g, ''))
    });
  },

  disableRadio: function (radio, yes) {
    if (yes) {
      radio.prop('disabled', true)
    } else {
      radio.prop('disabled', false)
    }
  },

  setHullClass: function (val) {
    //if it is half hull, check to ensure that the colour is not white.
    if (this.hulltype == 'HalfHull') {
      //If it is, then change to black
      if (val == "white") {
        alert('White is not available on Half Hulls');
        jQuery('#Fullhull-selections .Black').find(':radio').each(function () {
          //jQuery(this).removeAttr('checked');
          jQuery(this).click();
          //jQuery(this).removeAttr('checked');
        });
      } else {
        jQuery('#' + this.hulltype + '-preview').attr('class', val.toLowerCase());
      }
      //remove white as an option for half hull
      this.disableRadio(jQuery('#Fullhull-selections .White :radio'), true);
    } else {
      // var middleWhite = jQuery('#ctl01_ctl00_pbFormField6_ctl_middlestripecolour_6147_2');
      // var middleAnthracite = jQuery('#ctl01_ctl00_pbFormField6_ctl_middlestripecolour_6147_15');
      // if (val === "white") {
      //   if (middleWhite.prop('checked') === false) {
      //     middleWhite.trigger('click');
      //   }
      // } else {
      //   if (middleAnthracite.prop('checked') === false) {
      //     middleAnthracite.trigger('click');
      //   }
      // }
      // else, ensure white is added back as an option
      this.disableRadio(jQuery('#Fullhull-selections .White :radio'), false);
      jQuery('#' + this.hulltype + '-preview').attr('class', val.toLowerCase());
    }
  },

  setRadioEvent: function (object, preview, parentval, ishull) {
    var root = this;
    var value = "";
    if (parentval) {
      value = object.parent().attr('class').toLowerCase().replace(/ /g, '')
    }
    else {
      value = object.val().toLowerCase().replace(/ /g, '')
    }
    object.click(function () {
      if (ishull) {
        root.setHullClass(value)
      }
      else {
        preview.attr('class', value)
      }
    });
  },

  checktoggle: function () {
    //parse page
    var root = this;
    jQuery('.bmyb-col1 :checkbox').each(function (index) {
      var bn = jQuery(this).parent().attr('class').replace(/-option/g, '');
      var cssn = bn + '-selections';
      var selections = jQuery('#' + cssn);
      var preview = jQuery('#' + bn + '-preview');
      var pdef = typeof(preview) !== 'undefined';

      // Check if already enabled/disabled by default
      //if (jQuery(this).is(':checked')) {
      if (this.checked) {
        //CHECKED...set corresponding preview image
        if (bn == 'Stripe') {
          jQuery('#' + cssn + ' .colourset').each(function (index) {
            //iterate through all radios and set click event handler
            jQuery(this).find(':radio').each(function () {
              preview = jQuery('#' + bn + index + '-preview');
              if (jQuery(this).is(':checked')) {
                //update preview to reflect the already selected radio
                preview.attr('class', jQuery(this).val().toLowerCase().replace(/\s/g, ''));
              }
              //activate event handler
              root.setRadioEvent(jQuery(this), preview, false);
            });
          });
        } else {
          selections.find(':radio').each(function () {
            if (jQuery(this).is(':checked')) {
              if (bn == 'Vinyl') {
                preview.attr('class', jQuery(this).parent().attr('class').toLowerCase().replace(/ /g, ''))
              }
              else if (bn == "Fullhull") {
                var myval = jQuery(this).val().replace(/ /g, '');
                if ((myval == 'FullHull') || (myval == 'HalfHull')) {
                  root.setHullType(myval)
                }
                else {
                  root.setHullClass(myval)
                }
              } else {
                preview.attr('class', jQuery(this).val().toLowerCase().replace(/ /g, ''))
              }
            }
            //activate event handler
            if (bn == 'Vinyl') {
              root.setRadioEvent(jQuery(this), preview, true)
            }
            else if (bn == "Fullhull") {
              var myval = jQuery(this).val().replace(/ /g, '');
              if ((myval == 'FullHull') || (myval == 'HalfHull')) {
                root.setHullTypeRadioEvent(jQuery(this));
              }
              else {
                root.setRadioEvent(jQuery(this), preview, false, true)
              }
            } else {
              root.setRadioEvent(jQuery(this), preview, false)
            }
          });
        }
      } else {
        //UNCHECKED...find corressponding selections div and add new div to dom above selections div and remove corresponding preview image
        var doesntexist = typeof(jQuery('#' + cssn + '-overlay')) !== 'undefined';
        if (doesntexist) {
          jQuery('<div id="' + cssn + '-overlay" class="hideoverlay" style="height:' + selections.height() + 'px;"></div>').prependTo(selections);
        }
        if (bn == 'Stripe') {
          jQuery('#' + cssn + ' .colourset').each(function (index) {
            preview = jQuery('#' + bn + index + '-preview');
            preview.attr('class', '');
            jQuery(this).find(':radio').each(function () {
              root.setRadioEvent(jQuery(this), preview, false);
            });
          });
        } else {
          preview.attr('class', '');
          selections.find(':radio').each(function () {
            if (bn == 'Vinyl') {
              root.setRadioEvent(jQuery(this), preview, true);
            }
            else if (bn == "Fullhull") {
              var myval = jQuery(this).val().replace(/ /g, '');
              if ((myval == 'FullHull') || (myval == 'HalfHull')) {
                root.setHullTypeRadioEvent(jQuery(this));
              }
              else {
                root.setRadioEvent(jQuery(this), preview, false, true)
              }
            }
            else {
              root.setRadioEvent(jQuery(this), preview, false)
            }
          });
        }
        //save settings for some checkboxs
        if ((bn == 'Stripe') || (bn == 'Vinyl') || (bn == 'Fullhull') || (bn == 'Bimini')) {
          root.storeColours(bn);
        }
      }

      //Setup the click event handler (onchange does not fire in IE)
      ////jQuery(this).click( function() {
      jQuery(this).on('click', function () {
        ////if (jQuery(this).is(':checked')) {
        if (!this.checked) {
          //UNCHECKED - TURN ON
          var myoverlay = typeof(jQuery('#' + bn + '-selections-overlay')) !== 'undefined';
          if (myoverlay) {
            jQuery('#' + bn + '-selections-overlay').remove();
          }
          //find the activated radio if it exists and update preview class
          if (pdef) {
            switch (bn) {
              case 'Stripe':
                // replace saved colours if they exist
                root.retrieveColours('Stripe');
                //store and reset vinyls
                jQuery('.Vinyl-option').find(':checkbox').each(function () {
                  if (this.checked) {
                    jQuery(this).click();
                  }
                });
                //update preview
                jQuery('#' + cssn + ' .colourset').each(function (index) {
                  jQuery('#' + bn + index + '-preview').attr('class', jQuery(this).find(':radio:checked').val().toLowerCase().replace(/\s/g, ''))
                });

                var hullColour = 'n/a';
                jQuery('#Fullhull-selections input[type=radio]').each(function () {
                  if (jQuery(this).prop('checked')) {
                    hullColour = jQuery(this).val().toLowerCase().replace(/\s/g, '');
                  }
                });

                // Select white/anthracite middle stripe when full hull colour selected
                // var middleWhite = jQuery('#ctl01_ctl00_pbFormField6_ctl_middlestripecolour_6147_2');
                // var middleAnthracite = jQuery('#ctl01_ctl00_pbFormField6_ctl_middlestripecolour_6147_15');
                // if (hullColour === "white") {
                //   if (middleWhite.prop('checked') === false) {
                //     middleWhite.trigger('click');
                //   }
                // } else {
                //   if (middleAnthracite.prop('checked') === false) {
                //     middleAnthracite.trigger('click');
                //   }
                // }

                break;
              case 'Fullhull':
                //store and reset vinyls
                jQuery('.Vinyl-option').find(':checkbox').each(function () {
                  if (this.checked) {
                    jQuery(this).click();
                  }
                });
                //retrieve saved hull colours
                root.retrieveColours('Fullhull');
                //update preview
                selections.find(':radio:checked').each(function (index) {
                  var myval = jQuery(this).val().replace(/ /g, '');
                  if ((myval == 'FullHull') || (myval == 'HalfHull')) {
                    root.setHullType(myval);
                  }
                  else {
                    root.setHullClass(myval);
                  }
                })
                break;
              case 'Vinyl':
                //reset to FullHull and white
                ////jQuery('#Fullhull-selections .FullHull').find(':radio').each(function() { if(!jQuery(this).is(':checked')){ jQuery(this).click(); } });
                ////jQuery('#Fullhull-selections .White').find(':radio').each(function() { if(!jQuery(this).is(':checked')){ jQuery(this).click(); } });
                //disable hull colour if it is set
                jQuery('.Fullhull-option').find(':checkbox').each(function () {
                  if (this.checked) {
                    jQuery(this).click();
                  }
                });
                //disable Stripes
                jQuery('.Stripe-option').find(':checkbox').each(function () {
                  if (this.checked) {
                    jQuery(this).click();
                  }
                });
                //retrieve vinyl settings
                root.retrieveColours('Vinyl');
                //update preview
                preview.attr('class', selections.find(':radio:checked').parent().attr('class').toLowerCase().replace(/ /g, ''));
                break;
              default:
                //ERROR FIX - Need to impletment check for value before implementing... ie/ .val() errors out when no radios are found
                if (bn == 'Bimini') {
                  root.retrieveColours('Bimini');
                }
                var mynewval = '';
                var hasaradio = typeof(selections.find(':radio:checked').each(function () {
                  mynewval = jQuery(this).val().toLowerCase().replace(/ /g, '');
                }));
                preview.attr('class', mynewval);
            }
          }
        } else {
          //CHECKED - TURN OFF...find corressponding selections div and add new div to dom above selections div
          var dv = typeof(jQuery('#' + bn + '-selections-overlay')) !== 'undefined';
          if (dv) {
            jQuery('<div id="' + bn + '-selections-overlay" class="hideoverlay" style="height:' + selections.height() + 'px;"></div>').prependTo(selections);
          }
          //remove preview class
          if (pdef) {
            switch (bn) {
              case 'Stripe':
                root.storeColours('Stripe');
                jQuery('#' + cssn + ' .colourset').each(function (index) {
                  jQuery('#' + bn + index + '-preview').attr('class', '')
                });
                break;
              case 'Fullhull':
                root.storeColours('Fullhull');
                //remove fullhull class & halfhull class
                jQuery('#' + root.hulltype + '-preview').attr('class', '');
                break;
              case 'Vinyl':
                root.storeColours('Vinyl');
                preview.attr('class', '');
                break;
              case 'Bimini':
                root.storeColours('Bimini');
                preview.attr('class', '');
                break;
              default:
                preview.attr('class', '');
            }
          }
        }
      });
    });
  },

  addBottomPager: function () {
    var baseDomElem = jQuery('.bmyb-pager').parent().parent();
    var newDomElem = jQuery('.bmyb-pager').clone();
    newDomElem.find('input').each(function () {
      jQuery(this).attr('id', jQuery(this).attr('id') + '_bp');
    });
    newDomElem.appendTo(baseDomElem);
  },

  init: function (num) {
    jQuery('.bmyb-col1 :checkbox:not([safari])').checkbox();
    jQuery('.bmyb-col1 input[safari]:checkbox').checkbox({cls: 'jquery-safari-checkbox'});
    this.colourset();
    this.checktoggle();
    //this.addBottomPager();
    this.convertOptions();
  }
}

